// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1wEzQ","insightsList":"newBusinessInsightsMenu_insightsList__1thC4","active":"newBusinessInsightsMenu_active__1gxnZ"};